import React, { useEffect } from 'react';

const ImageZoomModal = ({ src, alt, onClose }) => {
    useEffect(() => {
        if (!src) return undefined;
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [src, onClose]);

    if (!src) return null;
    return (
        <div className="image-modal-overlay show-modal" onClick={onClose} role="dialog" aria-label="Cert image">
            <img src={src} alt={alt || 'Cert'} className="image-modal-content" />
        </div>
    );
};

export default ImageZoomModal;
